import React, { FC } from 'react';
import { useSelector, selectors, useDispatch, utils } from '@lib/azgaz-ui/connect';
import { CarsList as AuiCarsList } from '@azgaz/azgaz-ui';
import { useBrandCars } from '@/hooks';
import { removeOfficeFromUrl } from '@/utils';
import CarsItem from '../CarsItem';
import { actions } from '../../store/dealers';

const CarsList: FC = () => {
  const dispatch = useDispatch();
  const filters = useSelector(selectors.getFiltersValues);
  const { brandCars, vehiclesLoading } = useBrandCars();
  const { isZeroPage } = useSelector(selectors.getIsPageLoading);

  const uiHelper = new utils.UiHelper({
    filters,
    dispatch,
  });

  const onFiltersReset = React.useCallback(() => {
    uiHelper.resetFilters();
    dispatch(actions.resetDealerSelectedValues());
    removeOfficeFromUrl();
  }, []);

  return brandCars ? (
    <AuiCarsList
      cars={brandCars}
      isZeroPageLoading={isZeroPage || vehiclesLoading}
      clearFilters={onFiltersReset}
      Item={CarsItem}
    />
  ) : null;
};

export default CarsList;
